import { SSEResponseTypes } from "/models/websockets.types";

export enum InitialPromptType {
    TEXT="text",
    VOICE="voice",
    FILE_UPLOAD="file_upload"
}

export type VoiceCallEndReason = 'user' | 'agent_left' | 'disconnected' | 'error';

export enum FeatureName {
    SEARCH="search",
    CREATE_IMAGE="create_image",
    READ_ALOUD="read_aloud"
}

export interface PageLoadEventProps {
    loadTimeMs: number;
    domContentLoadedTimeMs: number;
    firstContentfulPaintTimeMs: number;
    timeToInteractiveTimeMs: number;
    pagePath: string;
    userId: string;
    deviceType: string;
    connectionType: string;
    timestamp: string;
}

export interface SessionStartedEventProps {
    sessionId: string;
    userId: string;
    entryPage: string;
    referrer: string;
    deviceType: string;
    timestamp: string;
}

export interface SessionEndedEventProps {
    sessionId: string;
    userId: string;
    sessionDurationSeconds: number;
    activeTimeSeconds: number;
    pagesVisited: number;
    exitPage: string;
    endReason: string;
    timestamp: string;
}

export interface UserIdleEventProps {
    idleDurationSeconds: number;
    idleThresholdSeconds: number;
    lastActivePage: string;
    sessionId: string;
    userId: string;
    totalActiveTimeSeconds: number;
    timestamp: string;
}

export const EVENTS = {
    PAGE_VIEW: (page: any) => ({ name: '$pageview', properties: { page } }),
    PAGE_VIEW_CUSTOM: (page: any) => ({ name: 'Page_Viewed', properties: { page } }),
    BUTTON_CLICK: (label: any) => ({ name: 'Button_Clicked', properties: { label } }),
    USER_LOGGED_IN: (userId: any) => ({ name: 'User_Logged_In', properties: { userId } }),
    USER_SIGNED_UP: (userId: any, additionalInfo: any) => ({ name: 'User_Signed_Up', properties: { userId, additionalInfo } }),
    FORM_SUBMITTED: (formName: any) => ({ name: 'Form_Submitted', properties: { formName } }),
    ERROR: (error: any, additionalInfo: any) => ({ name: 'Custom_Error', properties: { error, additionalInfo } }),
    NEW_CHAT_STARTED: (conversationId: string, initialPromptType: InitialPromptType ) => ({ name: 'New_Chat_Started', properties: { conversationId, initialPromptType } }),
    MESSAGE_SENT: (conversationId: string, messageLength: number) => ({ name: 'Message_Sent', properties: { conversationId, messageLength } }),
    FEATURE_USED: (featureName: FeatureName) => ({ name: 'Feature_Used', properties: { featureName } }),
    PAGE_LOAD_COMPLETE: (pageLoadEventProps: PageLoadEventProps) => ({ name: 'Page_Load_Complete', properties: { ...pageLoadEventProps} }),
    SESSION_STARTED: (sessionStartedEventProps: SessionStartedEventProps) => ({ name: 'Session_Started', properties: { ...sessionStartedEventProps } }),
    SESSION_ENDED: (sessionEndedEventProps: SessionEndedEventProps) => ({ name: 'Session_Ended', properties: { ...sessionEndedEventProps } }),
    USER_IDLE: (userIdleEventProps: UserIdleEventProps) => ({ name: 'User_Idle', properties: { ...userIdleEventProps } }),
    SSE_ERROR_RESPONSE: (responseType: SSEResponseTypes, additionalInfo: any) => ({ name: 'SSE_Error_Response', properties: { responseType, additionalInfo } }),
    SSE_INFO_RESPONSE: (responseType: SSEResponseTypes, additionalInfo: any) => ({ name: 'SSE_Info_Response', properties: { responseType, additionalInfo } }),
    VOICE_CALL_STARTED: (conversationId: string, agentId: string) => ({ name: 'Voice_Call_Started', properties: { conversationId, agentId } }),
    VOICE_CALL_ENDED: (conversationId: string | null, durationSeconds: number, reason: VoiceCallEndReason) => ({ name: 'Voice_Call_Ended', properties: { conversationId, durationSeconds, reason } }),
};